import { __rest } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useMemo } from 'react';
import { styled } from '@mui/material';
import MuiBox from '@mui/material/Box';
import { ReactComponent as ForwardRef } from '../../../assets/icons/ResetMedium.svg.js';
import Button from '../../Button/Button.js';
import '../../Button/SplitButton.js';
import Checkbox from '../../Checkbox/Checkbox.js';
import '../../Checkbox/CheckboxList.js';

const Root = styled(MuiBox, { shouldForwardProp: prop => !['isInline'].includes(prop) }) `
  grid-area: 2 / 1 / 2 / 4;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  height: 60px;
  border-radius: 0 0 4px 4px;
  ${({ theme, isInline }) => `
    background-color: ${theme.palette.N60.main};
    box-shadow: ${isInline ? 'unset' : `0px 24px 32px ${theme.palette.N95.main}`};
    border-top: 1px solid ${theme.palette.N50.main};
    padding: ${theme.spacing(3, 5)};
  `}
`;
const ResetButton = styled(Button) `
  width: 102px;
`;
const _Button = styled(Button) `
  width: 116px;
`;
const CancelButton = styled(_Button) `
  margin: ${({ theme }) => `${theme.spacing(0, 4)}`};
`;
const ButtonsWrapper = styled(MuiBox) `
  display: flex;
  flex-direction: row;
  align-items: center;
  flex: 1;
  justify-content: flex-end;
`;
const RangeDateFooter = (_a) => {
    var { onApply, onCancel, onReset, hasNoEnd, onNoEnd, isWeekPicker, noEndLabel, resetLabel, cancelLabel, applyLabel, cancelHint, applyHint, resetHint, value, allowSingleRange, hasReset = true, isInline = false } = _a, rest = __rest(_a, ["onApply", "onCancel", "onReset", "hasNoEnd", "onNoEnd", "isWeekPicker", "noEndLabel", "resetLabel", "cancelLabel", "applyLabel", "cancelHint", "applyHint", "resetHint", "value", "allowSingleRange", "hasReset", "isInline"]);
    const isNoEndDisabled = useMemo(() => {
        if (!isWeekPicker) {
            return !!(value === null || value === void 0 ? void 0 : value[1]) || !(value === null || value === void 0 ? void 0 : value[0]);
        }
        return true;
    }, [isWeekPicker, value]);
    const applyDisabled = useMemo(() => {
        const hasStartDate = !!(value === null || value === void 0 ? void 0 : value[0]);
        const hasEndDate = allowSingleRange || hasNoEnd || !!(value === null || value === void 0 ? void 0 : value[1]);
        return !hasStartDate || !hasEndDate;
    }, [allowSingleRange, value, hasNoEnd]);
    return (jsxs(Root, Object.assign({}, rest, { isInline: isInline, "data-testid": "range-date-picker-footer" }, { children: [typeof hasNoEnd === 'boolean' && (jsx(Checkbox, Object.assign({ "data-testid": "range-date-picker-no-end", checked: (value === null || value === void 0 ? void 0 : value[0]) ? hasNoEnd : false, onChange: (_, updatedValue) => {
                    onNoEnd === null || onNoEnd === void 0 ? void 0 : onNoEnd(updatedValue);
                }, disabled: isNoEndDisabled }, { children: noEndLabel }))), typeof hasNoEnd !== 'boolean' && hasReset && (jsx(ResetButton, Object.assign({ hint: resetHint, startIcon: jsx(ForwardRef, {}), variant: "ghost", onClick: onReset, "data-testid": "range-date-picker-reset" }, { children: resetLabel }))), jsxs(ButtonsWrapper, { children: [jsx(CancelButton, Object.assign({ hint: cancelHint, variant: "secondary", onClick: onCancel, "data-testid": "range-date-picker-cancel" }, { children: cancelLabel })), jsx(_Button, Object.assign({ "data-testid": "range-date-picker-apply", hint: applyHint, onClick: onApply, disabled: applyDisabled }, { children: applyLabel }))] })] })));
};

export { RangeDateFooter as default };
//# sourceMappingURL=RangeDateFooter.js.map
